import {Button, Col, Icon, Row} from 'antd';
import moment from 'moment';
import React from 'react';

const AvailabilityHeader = ({onChange, onPropagateNavigate, selectedMonth, value}) => {

  const onNavigate = () => {
    onChange(value.clone().month(selectedMonth));
  }

  React.useEffect(() => {
      onNavigate();
    }, [selectedMonth]
  );

  const limit = moment().add(3, 'months');
  const months = [];
  for (let current = moment(); current.isSameOrBefore(limit); current.add(1, 'month')) {
    months.push(current.month());
  }

  const localeData = value.localeData();
  const currentMonth = value.month();

  // workaround to modulo with negative value
  const previous = months.includes((((currentMonth - 1) % 12) + 12) % 12);
  const next = months.includes((currentMonth + 1) % 12);

  return (
    <Row type="flex" justify="space-between" align="middle" style={{paddingTop: 16, paddingBottom: 16}}>
      <Col span={8} style={{display: 'flex', justifyContent: 'center'}}>
        <Button type="link" disabled={!previous} onClick={() => onPropagateNavigate(currentMonth - 1)}>
          <Icon type="left" className={previous ? 'branded-color' : 'branded-color-disabled'}/>
        </Button>
      </Col>
      <Col span={8} style={{display: 'flex', justifyContent: 'center'}}>
        {localeData._months[currentMonth]}
      </Col>
      <Col span={8} style={{display: 'flex', justifyContent: 'center'}}>
        <Button type="link" disabled={!next} onClick={() => onPropagateNavigate(currentMonth + 1)}>
          <Icon type="right" className={next ? 'branded-color' : 'branded-color-disabled'}/>
        </Button>
      </Col>
    </Row>
  )
}

export default AvailabilityHeader
